module.exports = __webpack_public_path__ + "img/brink1-cover.ce8b8613.jpg";